import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { stats } from '../content/portfolio';
import Reveal from './Reveal';

const Stats: React.FC = () => {
  const { language } = useLanguage();
  const c = stats[language];

  return (
    <section
      id="results"
      data-ink="#e8e6e1"
      data-field="#14120f"
      className="bg-code-surface py-24 text-code-text sm:py-32"
    >
      <div className="container-responsive">
        <Reveal>
          <h2 className="font-serif text-4xl font-medium sm:text-5xl">{c.title}</h2>
        </Reveal>

        <div className="mt-16 grid gap-x-10 gap-y-16 md:grid-cols-3">
          {c.items.map((item, i) => (
            <Reveal key={item.value} delay={i * 0.12} className={i === 1 ? 'md:mt-24' : i === 2 ? 'md:mt-48' : ''}>
              <p className="font-serif text-[clamp(56px,12.5vw,210px)] leading-[0.9] tracking-[-0.04em]">
                {item.value}
              </p>
              <p className="mt-5 max-w-xs text-xl leading-snug">{item.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
